import { pageConstants } from '../constants';

export function GetPage(state = {}, action) {
  switch (action.type) {
    case pageConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case pageConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case pageConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdatePage(state = {}, action) {
  switch (action.type) {
    case pageConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case pageConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case pageConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}